import React, { useState } from 'react'

const Inverters = (props) => {

  const [view, setView] = useState('')

  const { make, model, effRating } = props.inverter

  return (
    <div className='items'>
      <div>
        <p>{make} {model}</p>
      </div>
      <div>
        <span>Efficiency Rating: {effRating * 100}%</span>
      </div>
    </div>
  )
}

export default Inverters
